import { BillingClaimInvoiceStatus } from "@/Billing/Models/BillingClaimInvoiceStatus";
import { Guid } from "@/Common/Models/Guid";
import * as LocalOperations from "@/Common/Operations/operations.local";
import { LocalEvent } from "@/Common/Stores/Actions/LocalEvent";
import { BaseOperationHandler } from "@/Common/Stores/Handlers/Local/BaseOperationHandler";
import { BillingStore } from "../../BillingStore";

class BillingClaimStatusInboxHandler extends BaseOperationHandler {
    constructor() {
        super();

        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_ToDateChanged, this.toDateChanged);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_FromDateChanged, this.fromDateChanged);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_SelectAllSites, this.selectAllSites);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_SelectSite, this.selectSite);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_SelectedProvidersChanged, this.selectedProvidersChanged);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_SelectProvider, this.selectProvider);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_SelectInvoiceStatus, this.selectInvoiceStatus);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_SelectedInvoiceStatusesChanged, this.selectedInvoiceStatusesChanged);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_IsIgnoredChanged, this.isIgnoredChanged);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_ProviderFilterTextChanged, this.providerFilterTextChanged);
        this.RegisterOperation(LocalOperations.Billing.ClaimStatus_SearchSettings_QueryPageSizeChanged, this.queryPageSizeChanged);
    }

    private toDateChanged(request: LocalEvent, store: BillingStore): void {
        const dateTo = request.Get<Date>("value");
        const followCurrentTime = request.Get<boolean>("followCurrentTime") ?? false;
        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, dateTo, followCurrentTime };
    }

    private fromDateChanged(request: LocalEvent, store: BillingStore): void {
        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, dateFrom: request.Get<Date>("value") };
    }

    private selectAllSites(request: LocalEvent, store: BillingStore): void {
        const isAllSelected = request.Get<boolean>("isChecked");
        const selectedSiteIds = isAllSelected ? store.BillingClaimStatusInboxModel.orderedSites.map(site => site.Model.Id) : [];

        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, selectedSiteIds };
    }

    private selectSite(request: LocalEvent, store: BillingStore): void {
        const isChecked = request.Get<boolean>("isChecked");
        const siteId = request.Get<Guid>("siteId");
        const selectedSiteIds = isChecked ?
            [...store.BillingClaimStatusInboxModel.selectedSiteIds, siteId] :
            store.BillingClaimStatusInboxModel.selectedSiteIds.filter(selectedSiteId => selectedSiteId != siteId);

        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, selectedSiteIds };
    }

    private selectedProvidersChanged(request: LocalEvent, store: BillingStore): void {
        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, selectedProviderIds: request.Get<Guid[]>("selectedProviderIds") };
    }

    private selectProvider(request: LocalEvent, store: BillingStore): void {
        const isChecked = request.Get<boolean>("isChecked");
        const clinicianId = request.Get<Guid>("clinicianId");
        const selectedProviderIds = isChecked ?
            [...store.BillingClaimStatusInboxModel.selectedProviderIds, clinicianId] :
            store.BillingClaimStatusInboxModel.selectedProviderIds.filter(selectedClinicianId => selectedClinicianId !== clinicianId);

        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, selectedProviderIds };
    }

    private selectedInvoiceStatusesChanged(request: LocalEvent, store: BillingStore): void {
        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, selectedInvoiceStatus: request.Get<number[]>("selectedInvoiceStatus") };
    }

    private selectInvoiceStatus(request: LocalEvent, store: BillingStore): void {
        const isChecked = request.Get<boolean>("isChecked");
        const status = request.Get<BillingClaimInvoiceStatus>("status");
        const selectedInvoiceStatus = isChecked ?
            [...store.BillingClaimStatusInboxModel.selectedInvoiceStatus, status] :
            store.BillingClaimStatusInboxModel.selectedInvoiceStatus.filter(selectedStatus => selectedStatus !== status);

        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, selectedInvoiceStatus };
    }

    private isIgnoredChanged(request: LocalEvent, store: BillingStore): void {
        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, isIgnored: request.Get<boolean>("isIgnored") };
    }

    private providerFilterTextChanged(request: LocalEvent, store: BillingStore): void {
        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, providerSearchText: request.Get<string>("providerSearchText") };
    }

    private queryPageSizeChanged(request: LocalEvent, store: BillingStore): void {
        store.BillingClaimStatusInboxModel = { ...store.BillingClaimStatusInboxModel, queryPageSize: request.Get<number>("queryPageSize") };
    }
}

export { BillingClaimStatusInboxHandler };
